import { NotificationPosition } from 'coreOld/enums';
import { setNotification } from 'coreOld/slices/notificationsSlice';
import { INotification } from 'coreOld/types';

import { useAppDispatch, useAppSelector } from './redux';

export const useNotification = () => {
  const { notification } = useAppSelector((state) => state.notification);

  const dispatch = useAppDispatch();

  const showNotification = (notification: INotification) => {
    if (notification) {
      dispatch(setNotification(notification));
    }
  };

  const clearModalNotification = () => {
    if (!notification) {
      return;
    }

    if ((notification?.position as any) === NotificationPosition.MODAL) {
      clearNotification();
    }
  };

  const clearNotification = () => dispatch(setNotification(null));

  return {
    showNotification,
    clearModalNotification,
    clearNotification,
  };
};
